import { Currencies, ExtendedCurrencies } from '@constants/enums';
import {
  BlockedCountries,
  CountriesToShowDefaultCurrency,
} from '@pages/clients/AddContactForm/constants';

interface BlockedCurrency {
  /**
   * Currency that is blocked for payments
   */
  currency: Currencies | ExtendedCurrencies;
  /**
   * Reason key for the blocked currency
   */
  reasonKey: string;
}

export interface BlockedCountry {
  country: BlockedCountries;
  reasonKey: string;
}

export const BLOCKED_CURRENCIES: BlockedCurrency[] = [
  // {
  //   currency: ExtendedCurrencies.CNY,
  //   reasonKey: 'paymentBlockedChinaReason',
  // },
];

export const BLOCKED_COUNTRIES: BlockedCountry[] = [
  {
    country: BlockedCountries.DO,
    reasonKey: 'paymentBlockedDOReason',
  },
];

export const isPaymentBlocked = (
  currency: Currencies | ExtendedCurrencies,
  country?: string
): boolean =>
  BLOCKED_CURRENCIES.some((blocked) => blocked.currency === currency) ||
  BLOCKED_COUNTRIES.some((blocked) => blocked.country === country);

export const getBlockedPaymentReasonKey = (
  currency: Currencies | ExtendedCurrencies,
  country?: string
): string | null => {
  const blocked = BLOCKED_CURRENCIES.find((item) => item.currency === currency);
  const blockedCountry = BLOCKED_COUNTRIES.find(
    (item) => item.country === country
  );
  if (blocked) return blocked.reasonKey;
  if (blockedCountry) return blockedCountry.reasonKey;
  return null;
};

export const showChinaPaymentWarning = (
  originCurrency: Currencies | ExtendedCurrencies,
  destinationCountry: string
) => {
  if (
    originCurrency !== Currencies.MXN &&
    destinationCountry === CountriesToShowDefaultCurrency.CN
  ) {
    return true;
  }

  return false;
};
